<template>
  <div class="construcPic">
    <div class="titleWrapper" :class="border?'bottom_border':''">
      <span class="title verticalTop">{{label}}</span>
      <img @click="showImage(picture)" class="verticalTop picture" :src="item.url" v-for="(item,index) in picture" :key="index" alt="">
    </div>
  </div>
</template>

<script>
  import { ImagePreview } from 'vant';
  export default {
    name: "construcPic",
    components: {
      [ImagePreview.Component.name]: ImagePreview.Component,
    },
    props:{
      label:"",
      picture:{
        type:Array,
        default:() => {
          return []
        }
      },
      border:{
        type:Boolean,
        default:true
      }
    },
    methods: {
      showImage(picture){
        let list=[];
        picture.forEach(item=>{
          list.push(item.url)
        })
        ImagePreview({images:list,closeable: true});
      }
    }
  }
</script>

<style scoped lang="less">
  .construcPic{
    .titleWrapper{
      padding:12px 10px 0 0;
      min-height: 47px;
      box-sizing: border-box;
      color:#000000;
      position: relative;
      padding-left: 85px;
      .title{
        font-size: 15px;
        font-weight: bolder;
        display: inline-block;
        min-width: 75px;
        position:absolute;
        left: 10px;

      }
      .values{
        font-size: 14px;
      }
    }
    .bottom_border{
      border-bottom: 1px solid #EBEBEB;
    }
    img{
      width: 70px;
      height: 70px;
      margin-right: 15px;
      margin-bottom: 15px;
      &:nth-of-type(3n){
        margin-right:0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/construcPic.vue